module.exports = __webpack_public_path__ + "img/mobile-nav-3.cf16ea18.png";